import { isSection } from '@tunasong/models'
import type { Scale } from '@tunasong/schemas'
import { useEditor } from '@tunasong/plugin-lib'
import type { TunaEditor } from '@tunasong/plugin-lib'
import { isSong } from '@tunasong/schemas'
import type { CoreElement } from '@tunasong/schemas'
import { Location, Node, Path, Range } from 'slate'
import { ReactEditor } from 'slate-react'

const resolveScale = (editor: TunaEditor, location: Location | null | undefined): Scale | null => {
  const rootScale = isSong(editor.rootElement) ? (editor.rootElement.scale as Scale) : null
  if (!location) {
    return rootScale
  }

  let scale = rootScale
  try {
    const path = Path.isPath(location) ? location : Range.isRange(location) ? location.anchor.path : location.path
    const parents = Node.ancestors(editor as never, path)
    for (const [parent] of parents) {
      if (isSection(parent) && parent.scale) {
        scale = parent.scale
        break
      }
    }
  } catch {}
  return scale
}

/** Detect the Scale from the editor context.  */
export const useScalePath = (editor: TunaEditor, location?: Location | null) =>
  resolveScale(editor, location)

/** @deprecated use useScalePath instead */
export const useScale = (element?: CoreElement, sourcePath?: Path | null) => {
  const editor = useEditor()

  let path: Path | null = sourcePath ?? null
  if (!path && element) {
    try {
      path = ReactEditor.findPath(editor as unknown as ReactEditor, element)
    } catch {
      path = null
    }
  }

  return resolveScale(editor, path)
}
